module.exports = __webpack_public_path__ + "img/661-a3c58f.png";